import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const CameraEditModal = ({ isOpen, toggle, cameraData, aiStatusData, onStatusUpdate, isUpdatingStatus }) => {

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        Camera Details - {cameraData?.camera_name || 'Camera'}
      </ModalHeader>
      <ModalBody>
        {/* <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label fw-bold">Camera ID:</label>
              <p className="mb-0">{cameraData?.camera_id || 'N/A'}</p>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Camera Name:</label>
              <p className="mb-0">{cameraData?.camera_name || 'N/A'}</p>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Area:</label>
              <p className="mb-0">{cameraData?.area || 'N/A'}</p>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Sub Area:</label>
              <p className="mb-0">{cameraData?.sub_area || 'N/A'}</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label fw-bold">Area Owner:</label>
              <p className="mb-0">{cameraData?.area_owner || 'N/A'}</p>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Status:</label>
              <span className={`badge ${cameraData?.active ? 'bg-success' : 'bg-danger'}`}>
                {cameraData?.active ? 'Active' : 'Inactive'}
              </span>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Last Active:</label>
              <p className="mb-0">{cameraData?.last_active || 'N/A'}</p>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Modules:</label>
              <div>
                {cameraData?.modules?.map((module, index) => (
                  <span key={index} className="badge bg-info me-1">
                    {module?.module_name}
                  </span>
                )) || 'N/A'}
              </div>
            </div>
          </div>
        </div> */}
        
        {/* {cameraData?.image_url && (
          <div className="mt-3">
            <label className="form-label fw-bold">Camera Image:</label>
            <div className="text-center">
              <img 
                src={cameraData.image_url} 
                alt="Camera" 
                className="img-fluid rounded"
                style={{ maxHeight: '200px', maxWidth: '300px' }}
              />
            </div>
          </div>
        )} */}

        {/* AI Status Section */}
        <div className="mt-4">
          <label className="form-label fw-bold">AI Status Options:</label>
          {aiStatusData && aiStatusData.length > 0 ? (
            <div className="row">
              <div className="col-md-8">
                <select 
                  className="form-select"
                  id="aiStatusSelect"
                >
                  <option value="">Select AI Status...</option>
                  {aiStatusData.map((status) => (
                    <option key={status.id} value={status.id}>
                      {status.status} - {status.description}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <Button 
                  color="primary"
                  disabled={isUpdatingStatus}
                  onClick={() => {
                    const selectElement = document.getElementById('aiStatusSelect');
                    if (selectElement.value) {
                      const selectedStatus = aiStatusData.find(status => status.id === parseInt(selectElement.value));
                      if (selectedStatus) {
                        console.log('Updating camera AI status:', {
                          camera_mapping_id: cameraData?.camera_id,
                          status_id: selectedStatus.id
                        });
                        onStatusUpdate(cameraData?.camera_id, selectedStatus.id);
                      }
                    } else {
                      alert('Please select an AI status option');
                    }
                  }}
                >
                  {isUpdatingStatus ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Updating...
                    </>
                  ) : (
                    'Update Status'
                  )}
                </Button>
              </div>
            </div>
          ) : (
            <div className="col-12">
              <p className="text-muted">No AI status options available.</p>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CameraEditModal;



